import Phaser from 'phaser';
import Player from './player';
import obstacles from './obstacles';

export default class gameScene extends Phaser.Scene {
  constructor() {
    super('game-Scene');
  }

  preload() {
    this.controls = this.input.keyboard.addKeys({
      jump: Phaser.Input.Keyboard.KeyCodes.SPACE,
    });
  }
  create() {
    this.map = this.make.tilemap({ key: 'grassland' });
    this.tileset = this.map.addTilesetImage('spritesheet', 'grassImage');
    // const layer2 = this.map.createLayer('Tile Layer 2', this.tileset, 0, 0);
    // const layer1 = this.map.createLayer('Tile Layer 1', this.tileset, 0, 0);
    const layer3 = this.map.createLayer('Tile Layer 3', this.tileset, 0, 0);
    this.background = this.add.tileSprite(
      0,
      0,
      this.game.config.width,
      this.game.config.height,
      'background'
    );
    this.background.setOrigin(0);
    this.background.setScrollFactor(0);

    layer3.setCollisionByProperty({ collides: true });
    this.player = new Player(this, 100, 100, 'player', 'tile000');
    // const graphics = this.add.graphics();
    // layer3.renderDebug(graphics, {
    //   tileColor: null,
    //   collidingTileColor: new Phaser.Display.Color(243, 134, 48, 200),
    //   faceColor: new Phaser.Display.Color(40, 39, 37, 255),
    // });
    this.physics.add.collider(this.player, layer3);

    this.obstacles = this.physics.add.group({
      classType: obstacles,
    });

    this.time.addEvent({
      delay: 2000,
      callback: () => {
        this.obstacles.get(600, 200, 'stone-05');
      },
      callbackScope: this,
      loop: true,
    });

    this.physics.add.collider(
      this.player,
      this.obstacles,
      this.obstacleCollide,
      null,
      this
    );
  }

  obstacleCollide() {
    this.scene.sendToBack('game-Scene');
    this.scene.pause('game-Scene');
    this.sys.game.gameState = this.sys.game.GAMESTATES.GAMEOVER;
    this.sys.game.menuText.setText(
      this.sys.game.menuTexts[this.sys.game.gameState]
    );
  }

  update(time, deltaTime) {
    this.obstacles.children.iterate((obstacle) => {
      obstacle.update();
    });
    this.player.update(this.controls);
    this.background.tilePositionX += 3;
  }
}
